// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__iI9U2","container":"Tooltip_container__3ju32","tip":"Tooltip_tip__3iGDa"};